import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Layout.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '',
        component: () => import('../views/frontend/Home.vue'),
      },
      {
        path: '/contact',
        component: () => import('../views/frontend/Contact.vue'),
      },
      {
        path: '/products',
        component: () => import('../views/frontend/Products.vue'),
      },
      {
        path: '/sellwines',
        component: () => import('../views/sellwine/SellWine.vue'),
      },
      {
        path: '/warehouse',
        component: () => import('../views/warehouse/Warehouse.vue'),
      },
      {
        path: '/wines',
        component: () => import('../views/wines/Wines.vue'),
      },
      
    
     
    ],
  },
  {
    path: '/login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/admin',
    component: () => import('../views/Dashboard.vue'),
    children: [
      {
        path: 'products',
        component: () => import('../views/backend/Products.vue'),
      },
      {
        path: 'orders',
        component: () => import('../views/backend/Orders.vue'),
      },
      {
        path: 'coupons',
        component: () => import('../views/backend/Coupons.vue'),
      },
    ],
  },
  // redirect 的功能是當使用者輸入不存在的路徑時，會自動導向至指定路徑
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  linkExactActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
